const FADE_OUT_MS = 200;

/** Fades out and removes the startup loader from index.html and marks the app container as no longer busy. */
export function hideAppLoader() {
    document.getElementById('app')?.removeAttribute('aria-busy');

    const loader = document.getElementById('app-loader');
    if (!loader) return;

    loader.classList.add('is-hidden');
    window.setTimeout(() => loader.remove(), FADE_OUT_MS);
}
